// extracted by mini-css-extract-plugin
export var active = "_am-d";
export var blink = "_am-e";
export var container = "_am-5";
export var controls = "_am-0";
export var controlsRight = "_am-1";
export var fakeCursor = "_am-c";
export var hidden = "_am-b";
export var quillContainerSmall = "_am-7";
export var quillEditor = "_am-6";
export var quillEditorSmall = "_am-8";
export var quillFormatButtons = "_am-a";
export var quillToolbar = "_am-9";
export var removePadding = "_am-2";
export var state = "_am-3";
export var stateTitle = "_am-4";